import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type BoxGifSliderContent } from '../../../shared/types/boxGifSlider';
import { type FragmentContext } from '../../../shared/types/fragmentContext';
import { LazySlider } from '../LazySlider';
import { boxGifSliderConfig } from './boxGifSliderConfig';
import { BoxGifWrapper } from './BoxGifWrapper/BoxGifWrapper';
import styles from './BoxGifSlider.module.scss';

const messages = defineMessages({
    a11yPreviousSlide: { defaultMessage: 'Zur vorherigen Seite' },
    a11yNextSlide: { defaultMessage: 'Zur nächsten Seite' },
});

type BoxGifSliderProps = {
    readonly boxGifSliderData?: BoxGifSliderContent;
};

const BoxGifSlider = ({ boxGifSliderData }: BoxGifSliderProps): JSX.Element | null => {
    const intl = useIntl();
    const sliderConfig = boxGifSliderConfig;

    const { isMydays } = useFragmentContext<FragmentContext>();

    if (!boxGifSliderData) {
        return null;
    }

    const { headline, items, subheadline } = isMydays ? boxGifSliderData.md : boxGifSliderData.js;

    const preparedSlides = items.map((item, index) => ({
        key: `${index}`,
        content: (
            <BoxGifWrapper
                title={item.title}
                description={item.description}
                gif={item.gif}
                lazyLoad
            />
        ),
    }));

    return (
        <div
            className={classNames(styles.wrapper, {
                'text-left text-sm-center mx-auto': isMydays,
            })}
        >
            <p className={classNames(styles.headline, 'theme-text-headline pb-1-5x')}>{headline}</p>
            <p className={classNames(styles.subheadline, 'mb-2x')}>{subheadline}</p>
            <div className={styles.sliderWrapper}>
                <LazySlider
                    a11yNextSlide={intl.formatMessage(messages.a11yNextSlide)}
                    a11yPreviousSlide={intl.formatMessage(messages.a11yPreviousSlide)}
                    slides={preparedSlides}
                    config={sliderConfig}
                />
            </div>
        </div>
    );
};

export { BoxGifSlider };
